import { render, staticRenderFns } from "./Suggestion.vue?vue&type=template&id=35a1eb4c"
import script from "./Suggestion.vue?vue&type=script&lang=js"
export * from "./Suggestion.vue?vue&type=script&lang=js"
import style0 from "./Suggestion.vue?vue&type=style&index=0&id=35a1eb4c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports